<div [formGroup]="form">
  <div formArrayName="OptionsSeat">
    <div *ngFor="let optionsSeat of OptionsSeat.controls; let i = index"
         class="size-form size-form_with-border">
      <div class="size-form__item">
        <div class="size-form__hint">Місце {{ i + 1 }}</div>
        <ng-container [formGroupName]="i">
          <div class="form-row wrappable">
            <div class="form-col form-col-1">
              <mat-form-field class="mat-block mat-block_placeholder-top">
                <input matInput
                       npNumber
                       [formControlName]="WEIGHT_INPUT_CONFIG.controlName"
                       [placeholder]="WEIGHT_INPUT_CONFIG.placeholder"
                       [maxValue]="WEIGHT_INPUT_CONFIG.maxValue"
                       [allowFloat]="WEIGHT_INPUT_CONFIG.allowFloat"
                       [digitsAfterDot]="WEIGHT_INPUT_CONFIG.digitsAfterDot"
                       [errorStateMatcher]="matcher"
                       [NumberInput]="true" />
                <div class="unit" matSuffix>{{ WEIGHT_INPUT_CONFIG.unit }}</div>
              </mat-form-field>
            </div>
            <div class="form-col form-col-1">
              <mat-form-field class="mat-block mat-block_placeholder-top">
                <input matInput
                       npNumber
                       [formControlName]="VOLUMETRIC_LENGTH_INPUT_CONFIG.controlName"
                       [placeholder]="VOLUMETRIC_LENGTH_INPUT_CONFIG.placeholder"
                       [maxValue]="VOLUMETRIC_LENGTH_INPUT_CONFIG.maxValue"
                       [allowFloat]="VOLUMETRIC_LENGTH_INPUT_CONFIG.allowFloat"
                       [maxInputLength]="VOLUMETRIC_LENGTH_INPUT_CONFIG.maxInputLength"
                       [errorStateMatcher]="matcher"
                       [NumberInput]="true"
                       (input)="recalculateVolumetricVolume(i)" />
                <div class="unit" matSuffix>{{ VOLUMETRIC_LENGTH_INPUT_CONFIG.unit }}</div>
              </mat-form-field>
            </div>
            <div class="form-col form-col-1">
              <mat-form-field class="mat-block mat-block_placeholder-top">
                <input matInput
                       npNumber
                       [formControlName]="VOLUMETRIC_WIDTH_INPUT_CONFIG.controlName"
                       [placeholder]="VOLUMETRIC_WIDTH_INPUT_CONFIG.placeholder"
                       [maxValue]="VOLUMETRIC_WIDTH_INPUT_CONFIG.maxValue"
                       [allowFloat]="VOLUMETRIC_WIDTH_INPUT_CONFIG.allowFloat"
                       [maxInputLength]="VOLUMETRIC_WIDTH_INPUT_CONFIG.maxInputLength"
                       [errorStateMatcher]="matcher"
                       [NumberInput]="true"
                       (input)="recalculateVolumetricVolume(i)" />
                <div class="unit" matSuffix>{{ VOLUMETRIC_WIDTH_INPUT_CONFIG.unit }}</div>
              </mat-form-field>
            </div>
            <div class="form-col form-col-1">
              <mat-form-field class="mat-block mat-block_placeholder-top">
                <input matInput
                       npNumber
                       [formControlName]="VOLUMETRIC_HEIGHT_INPUT_CONFIG.controlName"
                       [placeholder]="VOLUMETRIC_HEIGHT_INPUT_CONFIG.placeholder"
                       [maxValue]="VOLUMETRIC_HEIGHT_INPUT_CONFIG.maxValue"
                       [allowFloat]="VOLUMETRIC_HEIGHT_INPUT_CONFIG.allowFloat"
                       [maxInputLength]="VOLUMETRIC_HEIGHT_INPUT_CONFIG.maxInputLength"
                       [errorStateMatcher]="matcher"
                       [NumberInput]="true"
                       (input)="recalculateVolumetricVolume(i)" />
                <div class="unit" matSuffix>{{ VOLUMETRIC_HEIGHT_INPUT_CONFIG.unit }}</div>
              </mat-form-field>
            </div>
            <div *ngIf="isMultiPlace" class="form-col form-col-1 form-col-1_with_symbol">
              <mat-form-field class="mat-block mat-block_placeholder-top">
                <input matInput
                       npNumber
                       [formControlName]="PLACE_COST_INPUT_CONFIG.controlName"
                       [placeholder]="PLACE_COST_INPUT_CONFIG.placeholder"
                       [maxValue]="PLACE_COST_INPUT_CONFIG.maxValue"
                       [allowFloat]="PLACE_COST_INPUT_CONFIG.allowFloat"
                       [digitsAfterDot]="PLACE_COST_INPUT_CONFIG.digitsAfterDot"
                       [errorStateMatcher]="matcher"
                       [NumberInput]="true"
                       (input)="recalculatePlacesCost()" />
                <div class="unit" matSuffix>{{ PLACE_COST_INPUT_CONFIG.unit }}</div>
              </mat-form-field>
            </div>
            <div class="form-col form-col-1">
              <div class="info-cell">
                <div class="info-cell__label">
                  Об’ємна вага
                  <i class="material-icons icon-help info-cell__icon cursor-pointer"
                     matTooltipPosition="below"
                     [matTooltip]="VOLUMETRIC_WEIGHT_TOOLTIP">help_outline</i>
                </div>
                <div class="info-cell__content">
                  {{ optionsSeat.get(OptionsSeatControlNames.VolumetricVolume).value || '—' }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-row mr-bottom-16 special-cargo-container mt-3">
            <mat-checkbox
              formControlName="specialCargo"
              matTooltipPosition="below"
              [matTooltip]="getSpecialCargoTooltip(i)"
              [disabled]="!checkSpecialCargoCondition(i)"
            >
              Ручна обробка
            </mat-checkbox>
            <mat-icon class="material-icons icon-help icon-help_sm cursor-pointer"
                      matTooltipPosition="below"
                      [matTooltip]="SPECIAL_CARGO_HINT_TOOLTIP">
              help_outline
            </mat-icon>
          </div>
        </ng-container>
      </div>
      <div class="control-icons size-form__control-icons">
        <div class="control-icons__item">
          <button mat-icon-button>
            <mat-icon class="material-icons_grey"
                      matTooltipPosition="below"
                      [matTooltip]="'Копіювати місце'"
                      (click)="copyOptionsSeat(i)">
              content_copy
            </mat-icon>
          </button>
        </div>
        <div *ngIf="isMultiPlace" class="control-icons__item">
          <button mat-icon-button (click)="removeOptionsSeat(i)">
            <mat-icon class="material-icons_grey"
                      matTooltipPosition="below"
                      [matTooltip]="'Видалити місце'">
              close
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="form-row form-row_button">
    <div class="form-col form-col-2">
      <button type="button"
              class="mat-button_with-icon"
              mat-button color="primary"
              (click)="addOptionsSeat()">
        <mat-icon>add_circle</mat-icon>
        Додати місце
      </button>
    </div>
  </div>
</div>
